import './user-pages.sass';
import axios from 'axios';
import useAlert from '../hooks/useAlert';
import useConfirm from '../hooks/useConfirm';
import useUser from '../hooks/useUser';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

const Upgrade = () => {
	const { t, i18n } = useTranslation();
	const { sendAlert } = useAlert();
	const token = localStorage.getItem('token');
	const accountId = localStorage.getItem('accountId');
	const { sendConfirm } = useConfirm();
	const { user } = useUser();
	const { upgradeApply, role } = user;
	const navigate = useNavigate();

	const checkForm = (event) => {
		event.preventDefault();
		sendConfirm({
			title: t('upgrade.msg_hint'),
			onConfirm: submitForm,
		});
	}

	const submitForm = () => {
		axios.get(`/user/apply_vendor/${accountId}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}).then((response) => {
			const message = response.data.message;

			if (message === 'success') {
				sendAlert(t('upgrade.msg_applied'));
				navigate(0);
			}
		}).catch((error) => {
			const message = error.response.data.message;

			switch (message) {
				case 'This user has already been vendor':
					sendAlert(t('upgrade.msg_already'));
					break;

				case 'User not found':
					sendAlert(t('upgrade.msg_not_found'));
					break;

				default:
					sendAlert('Oops', message);
					break;
			}
		});
	}

	return (
		<div id='Upgrade' className='user-pages'>
			<div className='page-title'>{t('upgrade.title')}</div>
			
			<div className='page-content'>
				{/* { !upgradeApply ? (
					<div className='page-content'>經認證成為創作者後，即可上傳並販售您的作品或項目，一起加入我們的行列吧！</div>
				) : null } */}
				{upgradeApply ? (
					<div className='message'>{ role == 'customer' ? t('upgrade.msg_wait') : t('upgrade.msg_upgraded') }</div>
				) : (
					<form className='form' onSubmit={checkForm}>
						<div className='button-wrap'>

							<button>{t('upgrade.btn_submit')}</button>

						</div>
					</form>
				)}
			</div>

			<div className='monetization-block'>Google ad</div>
		</div>
	)
}

export default Upgrade;